import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Box, Card, Grid, Spinner, Text } from "theme-ui";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'
import {
  Heading,
  TextInput,
  Form,
  Button,
  SingleSelect,
  DataList,
  Card as LumosCard,
  useNotify
} from "@loanpal/lumos__core";
import { object, string } from "yup";
import logo from "../../images/goodleap-white-orange.svg";
import Loading from "../../utils/loading";
import {
  phone,
  phoneDigits,
  numberToMoney,
  numberToMoneyNoDecimal,
  moneyStringToNumber,
  validateMoneyInput
} from "../../utils/format";
import { default as ErrorPage } from "../../utils/error";
import { default as NotFoundPage } from "../../utils/not-found";
import {
  notifyAdminErrorMessage,
  postLoanShare as postLoanShareApi,
  classifyLoanShareCreateError,
  loanShareCreateErrorMessage,
} from "../../utils/api";
import { useEmbedIframeGuard } from "../../utils/embed-iframe-guard";
import {
  LoanAmountInput,
  ApplyStatesInput,
  FormLoanAmountText,
  ApplyCaptchaAndSubmit,
  LoanAmountLimitsWatcher,
  getLoanAmountLimitError,
} from "../../utils/apply-loan-amount-input";
import {
  resolveApplyStateEntries,
  toStateSelectItems,
} from "../../utils/shared-app-states";
import { BackBar } from "./back-button";

import { Loader, Flex } from '@aws-amplify/ui-react';

// api
import { API, graphqlOperation } from "aws-amplify";
import { getSharedApp } from "../../graphql/queries";
import { createGoodLinks } from "../../graphql/mutations";

import HOME_IMPROVEMENT from "../../images/HI_1.png";
import ROOF from "../../images/ROOF_1.png";
import SOLAR from "../../images/SOLAR_1.png";
import BATTERY from "../../images/BATTERY_1.png";
import REMODELING from "../../images/REMODEL_1.png";

const Main = ({ state, send }) => {
  const [token, setToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingPayment, setLoadingPayment] = useState(true);
  const [iframeLoading, setIframeLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [notifyAdminError, setNotifyAdminError] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const { id, client = state.context.sharedApp.clientId.toLowerCase() } = useParams();
  const [SharedApp, setSharedApp] = useState(state.context.sharedApp);
  const [payment, setPayment] = useState();
  const [displayResult, setDisplayResult] = useState(true);
  const [, setStates] = useState();
  const [statesItems, setStatesItems] = useState([]);
  const [goodLink, setGoodLink] = useState();
  const [canApply, setCanApply] = useState(false);
  const [captchaResponse, setCaptchaResponse] = useState("");
  const loanAmountBlockedRef = useRef(false);
  const [minAmount, setMinAmount] = useState();
  const [maxAmount, setMaxAmount] = useState();
  const [limitations, setLimitations] = useState();
  const [offers, setOffers] = useState();
  const [offerItems, setOfferItems] = useState([])
  const [singleOffer, setSingleOffer] = useState("");
  const [paymentAmount, setPaymentAmount] = useState({});
  const [singleState, setSingleState] = useState(state.context.selectedState || "");
  const [offerDesc, setOfferDesc] = useState();
  const [offerName, setOfferName] = useState();
  const phoneRegExp = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  const captchaRef = useRef(null);
  const captchaResponseRef = useRef("");
  captchaResponseRef.current = captchaResponse;
  const setCanApplyFromAmountCheck = useCallback((amountOk) => {
    loanAmountBlockedRef.current = !amountOk;
    if (!amountOk) {
      setCanApply(false);
      return;
    }
    const captchaOk = !!(
      captchaRef.current?.getValue?.() || captchaResponseRef.current
    );
    setCanApply(captchaOk);
  }, []);
  const { isEmbedded } = useEmbedIframeGuard();
  const { addSnack } = useNotify();
  const [submitButtonState, setSubmitButtonState] = useState(null);

  // Prepopulate with query string paramenters
  const [ searchParams ] = useSearchParams();
  const [formData, setFormData] = useState({
    fname: '',
    lname: '',
    email: '',
    phone: '',
    offerId: '',
    locked: false,
    productType: '',
    state: '',
    refnum: '',
    cost: '',
    channel: ''
  });

const handleSubmitButtonState = (isSubmit) => {
  setSubmitButtonState(isSubmit)
}

const sandbox_promotionId = "2345f0aa-db7a-42b9-807b-9e8a82b81ae3";
const prod_promotionId =  "26d09475-32ec-448c-bb43-9f70aea55644";
const host = window.location.host;
// Change environment dev/prod accordingly
const env = "prod";
const version = "2.0";

  useEffect(() => {
    setFormData({
      fname: searchParams.get('fname') || '',
      lname: searchParams.get('lname') || '',
      email: searchParams.get('email') || '',
      phone: searchParams.get('phone') || '',
      locked: searchParams.get('locked') === "true" || searchParams.get('locked') === "false" ? JSON.parse(searchParams.get('locked')) : false,
      prodType: searchParams.get('producttype') || '',
      state: searchParams.get('state') || '',
      refnum: searchParams.get('refnum') || '',
      offerId: searchParams.get('loanterm') || '',
      cost: searchParams.get('cost') || '',
      channel: searchParams.get('channel') || ''
    });
  }, [searchParams]);

  useEffect(() => {
    fetchSharedApp(id);
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if (token !== "") {
      window.location.href = token;
    }
  }, [token])

  useEffect(() => {
      if (paymentAmount.payment) {
        getPayment(singleOffer, paymentAmount.amount);
      }
    // eslint-disable-next-line
  }, [paymentAmount])

  useEffect(() => {
    if (SharedApp) {
      setPaymentAmount({ amount: SharedApp.loanAmount, payment: false });
      getOffers(
        SharedApp.clientId,
        SharedApp.channel,
        SharedApp.loanAmount,
        SharedApp.categoryId,
        state.context.selectedState || SharedApp.selectedState
      );
      getCategories(SharedApp.clientId, SharedApp.category);
    }
    // eslint-disable-next-line
  }, [SharedApp]);

  useEffect( () => {
    try {
      if (goodLink){
        console.log("This is a goodLink", goodLink);
        API.graphql(
          graphqlOperation(createGoodLinks, { input: goodLink })
        );
      }
    } catch (err) {
      console.log("error fetching Shared Apps");
    }
  }, [goodLink]);

  useEffect(() => {
    if (error && errorMessage !== "" && notifyAdminError) {
      notifyAdminErrorMessage(SharedApp, id, errorMessage, true, {
        blocking: true,
      });
    }
    // eslint-disable-next-line
  }, [error, errorMessage, notifyAdminError]);

  const showError = (message, { notifyAdmin = true } = {}) => {
    setNotifyAdminError(notifyAdmin);
    setErrorMessage(message);
    setError(true);
  };

const getPromotionId = () => {
  if (host.includes("sandox") || (env === "dev"))  {
    return sandbox_promotionId;
  } else  {
    return prod_promotionId;
  }
}

const productItems = [
    { label: 'Loan product', text: offerDesc},
    {
      label: 'Term and rate',
      text: offerName,
    }
  ];

const estimatedPayment = payment ? payment[0].calculations.map((pay) => ({
    label: pay.paymentDescription,
    text: <div>
          {loadingPayment ? (
            <SkeletonTheme baseColor="#d7d7d7" highlightColor="#f5f5f5">
              <Text variant="h3" as="h2">
                $ <Skeleton width={125} height={24} />
              </Text>
            </SkeletonTheme>
          ) : (
            <Text variant="h3" as="h2">
              {numberToMoney(pay.amount.value)}
              <span style={styles.period} color="neutral.base">
              &nbsp;{pay.interval === "MONTHLY" ? "/ month" : ""}
              </span>
            </Text>
          )}
          </div>,
  })) : {};


    const getPayment = async (offerId, loanAmount) => {
    setLoadingPayment(true);
    if (offerId === "" || loanAmount === "" || loanAmount <= minAmount || loanAmount > maxAmount || !validateMoneyInput(loanAmount)) {
      //TODO Throw errors if loanAmount is pass max or under min
      return;
    }
    try {
      const clientId = SharedApp.clientId;
      const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          promotionId: getPromotionId(),
          amount: loanAmount,
          offerId: offerId
        },
      };
      // get payment
      await API.get("developerApi", "/payments", myInit0)
      .then((response) => {
        setPayment(response);
        setLoadingPayment(false);
      },
      (err) => {
        showError("Error getting payments" + err);
        console.log("Error getting payments", err);
        setLoadingPayment(false);
      })

    } catch (err) {
      console.log("error getting payments");
      setLoadingPayment(false);
      return false;
    }
  };
  const getCategories = async (clientId, category) => {
    try {
    const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId
        },
      };
      // get categories
      await API.get("developerApi", "/categories", myInit0)
      .then((response) => {
        const cat = response.find(el => el.name === getCategoryName(category).toUpperCase());
        getLimitations(clientId, cat.id);
        setMinAmount(cat.minLoanAmount);
        setMaxAmount(cat.maxLoanAmount);
      },
      (err) => {
        showError("Error getting categories" + err);
        console.log("Error getting categories", err);
        setLoadingPayment(false);
      })
    } catch (err) {
      console.log("error getting categories", err);
      return false;
    }
  }
  const getLimitations = async (clientId, category) => {
    try {
    const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId
        },
      };
      // get categories
      await API.get("developerApi", "/limitations", myInit0)
      .then((response) => {
        const limitations = response.data.filter((element) => element.categoryId === category)
        setLimitations(limitations);
      },
      (err) => {
        showError("Error getting limitations" + err);
        console.log("Error getting limitations", err);
        setLoadingPayment(false);
      })
    } catch (err) {
      console.log("error getting limitations", err);
      return false;
    }
  }

    const getOffers = async (clientId, channel, loanAmount, categoryId, addressState) => {
    const applyOfferChannel = (offer) => {
      const ch =
        state.context.selectedChannel ||
        (Array.isArray(offer?.channels) && offer.channels[0]) ||
        SharedApp.channel;
      if (ch) {
        SharedApp.channel = ch;
      }
    };

    try {
      const myInit0 = {
        queryStringParameters: {
          apiId: `${clientId}ApiId`,
          apiKey: `${clientId}ApiKey`,
          clientId: clientId,
          promotionId: getPromotionId(),
          channel: channel,
          categoryId: categoryId,
          state: addressState || '',
          env: env
        },
      };

      // get offers
      await API.get("developerApi", "/offersByCategory", myInit0)
      .then((response) => {
        if (response.data.length > 0) {
          setOffers(response.data);
          let offersArrayOptions = [];
          offersArrayOptions = response.data
            .map((element) => [
              ...offersArrayOptions,
              { name: element.productCode.includes("DEFERRED") ? `${element.productName} - ${element.name}` : `${element.name} - ${element.productName}`, value: element.id },
            ])
            .flat();
          setOfferItems(offersArrayOptions);
          if (response.data.length === 1) {
            applyOfferChannel(response.data[0]);
            setSingleOffer(response.data[0].id);
            setOfferDesc(response.data[0].productDescription);
            setOfferName(response.data[0].name);
            let stateArrayOptions = [];
            const resolvedStates = resolveApplyStateEntries(
              SharedApp.states,
              response.data[0].states
            );
            setStates(JSON.stringify(resolvedStates));
            if (state.context.selectedState) {
              setSingleState(state.context.selectedState);
            } else if (resolvedStates.length === 1) {
              setSingleState(resolvedStates[0]);
            }
            stateArrayOptions = toStateSelectItems(resolvedStates);
            setStatesItems(stateArrayOptions);
            getPayment(response.data[0].id, loanAmount);
          } else if (searchParams.get('loanterm') && response.data.length > 1) {
            // set offer id based on parameter
            console.log("OFFERS", response.data);
            const offerParam = response.data.find(o => o.id === searchParams.get('loanterm'));
            console.log("OFFER PARAM", searchParams.get('loanterm'), offerParam);
            if (offerParam) {
              applyOfferChannel(offerParam);
              setSingleOffer(offerParam.id);
              setOfferDesc(offerParam.productDescription);
              setOfferName(offerParam.name);
              setStates(JSON.stringify(offerParam.states));
              if (addressState) {
                setSingleState(addressState);
              }
              let stateArrayOptions = [];
              stateArrayOptions = offerParam.states
                .map((element) => [
                  ...stateArrayOptions,
                  { name: element, value: element },
                ])
                .flat();
              setStatesItems(stateArrayOptions);
              getPayment(offerParam.id, loanAmount);
            }
          } else if (state.context.selectedOffer && response.data.length > 1) {
            const offerFromContext = response.data.find(
              (o) => o.id === state.context.selectedOffer
            );
            if (offerFromContext) {
              applyOfferChannel(offerFromContext);
              setSingleOffer(offerFromContext.id);
              setOfferDesc(offerFromContext.productDescription);
              setOfferName(offerFromContext.name);
              setStates(JSON.stringify(offerFromContext.states));
              if (state.context.selectedState) {
                setSingleState(state.context.selectedState);
              }
              let stateArrayOptions = [];
              stateArrayOptions = offerFromContext.states
                .map((element) => [
                  ...stateArrayOptions,
                  { name: element, value: element },
                ])
                .flat();
              setStatesItems(stateArrayOptions);
              getPayment(offerFromContext.id, loanAmount);
            }
          }
        } else {
          showError("Error getting offers, no offers returned");
          console.log("Error getting offers, no offers returned");
        }
      },
      (err) => {
        showError("Error getting offers" + err);
        console.log("Error getting offers", err);
      })

    } catch (err) {
      console.log("error getting Offers");
      return false;
    }
  };

  const getCategoryFromState = (category) => {
    if (category === "HOME IMPROVEMENT") return "HOME_IMPROVEMENT";
    else if (category === "ROOFING / WINDOWS / DOORS / SIDING / GEOTHERMAL / RESTORATION") return "ROOF";
    else if (category === "SOLAR") return "SOLAR";
    else if (category === "BATTERY") return "BATTERY";
    else if (category === "REMODELING") return "REMODELING";
  }

  async function fetchSharedApp(id) {
    try {
      if (state.context.sharedApp) {
        const cat = state.context.categories.find(c => c.id === state.context.selectedCategory);
        SharedApp.channel = state.context.selectedChannel || SharedApp.channel;
        SharedApp.categoryId = state.context.selectedCategory;
        SharedApp.category = getCategoryFromState(cat.name);
        SharedApp.selectedState = state.context.selectedState;
        SharedApp.referenceId = state.context.referenceNumber || SharedApp.referenceId;
        SharedApp.loanAmount = searchParams.get('cost') ? searchParams.get('cost') : SharedApp.loanAmount;
        if (state.context.salesRep) {
          SharedApp.submittingUser.email = state.context.salesRepEmail || state.context.salesRep.email || SharedApp.submittingUser.email;
          SharedApp.submittingUser.firstName = state.context.salesRepFName || state.context.salesRep.firstname || SharedApp.submittingUser.firstName;
          SharedApp.submittingUser.lastName = state.context.salesRepLName || state.context.salesRep.lastName || SharedApp.submittingUser.lastName;
          SharedApp.submittingUser.phone = state.context.salesRepPhone || state.context.salesRep.phone || SharedApp.submittingUser.phone;
        }
        setDisplayResult(JSON.parse(state.context.sharedApp.displayIframe));
      } else {
        const appData = await API.graphql(
          graphqlOperation(getSharedApp, { id: id })
        );
        const { clientId: cId, status: st } = appData.data.getSharedApp;
        const displayStatuses = ["ACTIVE", "TEST"];
        if (cId.toLowerCase() !== client || displayStatuses.indexOf(st) < 0) {
          setLoading(false);
          setNotFound(true);
          return null;
        }
        setSharedApp(appData.data.getSharedApp);
        setDisplayResult(JSON.parse(appData.data.getSharedApp.displayIframe));
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setNotFound(true);
      console.log("error fetching SharedApp", err);
    }
  }
  const handleEmailClick = async (payload, email) => {
    console.log(JSON.parse(payload));
    setIsSending(true)
    const freshCaptcha = captchaRef.current?.getValue?.() || captchaResponse;
    const data = await postLoanShareApi(SharedApp.clientId, payload, undefined, {
      sharedAppId: SharedApp.id ?? id,
      captchaResponse: freshCaptcha,
    });
      if (data.link !== "") {
        setIsSending(false);
        addSnack({
          variant: 'success',
          message: `Successfully sent application to ${email}`,
        });
      }
  }

  const handleClick = async (payload) => {
    try {
      setIsLoading(true);
      const freshCaptcha = captchaRef.current?.getValue?.() || captchaResponse;
      const data = await postLoanShareApi(SharedApp.clientId, payload, undefined, {
        sharedAppId: SharedApp.id ?? id,
        captchaResponse: freshCaptcha,
      });
      setIframeLoading(true);
      setTimeout(() => setIframeLoading(false), 5000);
      setToken(data.link);
      if (data.link !== "") setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      const { apiError, confirmedApiRejection, status } =
        classifyLoanShareCreateError(err);
      showError(loanShareCreateErrorMessage(err), {
        notifyAdmin: confirmedApiRejection,
      });
      if (!confirmedApiRejection) {
        console.warn(
          "loan-share outcome indeterminate; suppressing admin alert",
          { status, response: err?.response?.data, payload }
        );
      }
      if (String(apiError || "").toLowerCase().includes("captcha")) {
        setCanApply(false);
        captchaRef.current?.reset?.();
      }
      console.log("error creating Shared App", err?.response?.data || err);
    }
  };

  const handleCaptchaExpired = () => {
    setCaptchaResponse("");
    setCanApply(false);
    captchaRef.current?.reset?.();
  };

  const buildGoodLink = (values) => {
    if (values.email.includes("@goodleap.com")) return null;
    const gLink = {
      clientId: SharedApp.clientId,
      custFirstName: values.firstName,
      custLastName: values.lastName,
      custEmail: values.email,
      custMobile: values.mobile,
      custState: values.state,
      custLoanAmount: values.loanAmount,
      offerId: values.offer,
      emailSent: SharedApp.sendEmail,
    };
    setGoodLink(gLink);
  }

  const getReferenceId = (refId, mobile, lastName) => {
    console.log(SharedApp.integratorId);
    return refId === "lastName" ? lastName
           : refId === "mobilePhone" ? phoneDigits(mobile)
           : refId === "quickLink" ? "QuickLink"
           : refId === "integratorId" ? SharedApp.integratorId
           : refId !== "" ? SharedApp.referenceId
           : "QuickLink"
  }

  const buildPaydown = (values) => {
    if (
      !values.firstName ||
      !values.lastName ||
      !values.email ||
      !values.state ||
      !values.mobile ||
      !values.offer
    ) {
      return;
    }
    buildGoodLink(values);
    const {
      referenceId,
      offer,
      channel,
      state,
      email,
      firstName,
      lastName,
      mobile,
      salesRepEmail,
      salesRepFirstName,
      salesRepLastName,
      salesRepPhone,
      loanAmount,
      autopayIntent,
      sendEmail,
      integratorId
    } = values;

    return JSON.stringify({
      referenceNumber: getReferenceId(referenceId, mobile, lastName, integratorId),
      offerId: offer,
      channel: channel,
      state: state,
      applicant: {
        email: email,
        firstName: firstName,
        lastName: lastName,
      },
      submittingUser: {
        firstName: salesRepFirstName,
        lastName: salesRepLastName,
        email: salesRepEmail.trim(),
        phone: salesRepPhone,
      },
      amount: {
        value: loanAmount,
        type: "USD",
      },
      sendEmail: sendEmail,
      enrollments: [autopayIntent ? "AUTOPAY" : ""],
    });
  };

  const getCategory = (category) => {
    if (category === "HOME_IMPROVEMENT") return HOME_IMPROVEMENT
    else if (category === "ROOF") return ROOF;
    else if (category === "SOLAR") return SOLAR;
    else if (category === "BATTERY") return BATTERY;
    else if (category === "REMODELING") return REMODELING;
  }

  const getCategoryName = (category) => {
    if (category === "HOME_IMPROVEMENT") return "Home Improvement";
    else if (category === "ROOF") return "Roofing / Windows / Doors / Siding / Geothermal / Restoration";
    else if (category === "SOLAR") return "Solar";
    else if (category === "BATTERY") return "Battery";
    else if (category === "REMODELING") return "Remodeling";
  }

  return (
    <>
      {error && <ErrorPage sharedApp={SharedApp} errorMessage={errorMessage} />}
      {notFound && <NotFoundPage />}
      {loading && <Loading />}
      {token !== "" && displayResult && !loading && !error && !notFound && (
        <div className="container">
          {iframeLoading && <Loading />}
          {/*  <iframe
            title="GoodLeap"
            className="iframe"
            allowFullScreen
            src={token}
          /> */}
        </div>
      )}
      {token !== "" && !displayResult && !loading && !error && !notFound && (
        <Box
          sx={{
            maxWidth: "100%",
            mx: "auto"
          }}
        >
          <Box>
            <Heading
              className="heading-box"
              sx={{
                width: "960px",
                margin: "0 auto",
                backgroundColor: "#003439",
              }}
            >
              <img src={logo} alt="GoodLeap" style={styles.logo} />
            </Heading>
          </Box>
          <Box sx={{ pl: 6, pr: 6, pt: 4, width: ["960px", "640px", "480px"] }}>
            <>
              <Heading variant="h2">
                Thank you for your interest in GoodLeap financing.
              </Heading>
              <Box sx={{ pt: 2, fontSize: "18px" }}>
                An application form has been sent to your email address.
                <br />
                <br />
                If you have questions, reach out to{" "}
                <Text sx={{ fontWeight: 800 }}>
                  {SharedApp.submittingUser.firstName}{" "}
                  {SharedApp.submittingUser.lastName}
                </Text>{" "}
                at{" "}
                <Text sx={{ fontWeight: 800 }}>
                  {phone(SharedApp.submittingUser.phone)}
                </Text>{" "}
                or{" "}
                <Text sx={{ fontWeight: 800 }}>
                  {SharedApp.submittingUser.email}
                </Text>
                .
              </Box>
            </>
          </Box>
        </Box>
      )}
      {token === "" && !loading && !error && !notFound && (
        <Box
          sx={{
            maxWidth: "100%",
            mx: "auto",
            backgroundColor: "#f5f5f5",
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
          }}
        >
          <Box>
            <Heading
              className="heading-box"
              sx={{
                width: "960px",
                margin: "0 auto",
                backgroundColor: "#003439",
              }}
            >
              <img
                src={logo}
                alt="GoodLeap"
                style={styles.logo}
                className="logo"
              />
            </Heading>
          </Box>
          {!offers && (
            <Form>
            <Card
              sx={{
                width: 960,
                margin: "0 auto",
              }}
              className="card-form"
            >
              <Box sx={{ pl: 2, pr: 2, pb: 2 }}>
                <Text>
                  <span style={styles.bold}>Welcome!</span> Complete this form to see an ESTIMATED payment scenario. Use the $ amount suggested by our company representative.
                </Text>
                <Box as="p" sx={{ mb: 2 }}>
                  &nbsp;
                </Box>
                <Box sx={{ width: "100%", mb: 2, mt: 2  }}>
                  <Loader
                      variation="linear"
                      emptyColor="#ffffff"
                      filledColor="#F58320"
                      className="loader"
                      />
                </Box>
                <Box>
                  <Grid columns={[1, 2]} gap={[0, 3]}>
                    <TextInput
                      name="firstName"
                      label="First name"
                      autoComplete="off"
                      readOnly
                    />
                    <TextInput
                      name="lastName"
                      label="Last name"
                      autoComplete="off"
                      readOnly
                    />
                  </Grid>
                  <Grid columns={[1, 2]} gap={[0, 3]}>
                    <TextInput
                      name="email"
                      label="Email address"
                      autoComplete="off"
                      type="email"
                      readOnly
                    />
                    <TextInput
                      name="mobile"
                      label="Mobile number"
                      autoComplete="off"
                      type="phone"
                      description="Please enter 10 digit mobile number"
                      readOnly
                    />
                  </Grid>
                   <Grid columns={[1, 2]} gap={[0, 3]}>
                      <>
                       <Box sx={{ width: "100%", mr: 5, mt: 2 }}>
                        <SingleSelect
                          name="offer"
                          label={"Getting offers, one moment..."}
                          readOnly
                          items={[]}
                        />
                      </Box>
                      <Box sx={{ width: "30%", mr: 5 }}>
                      <SingleSelect
                        name="state"
                        label={"State"}
                        readOnly
                        size={20}
                        items={[]}
                      />
                      </Box>
                    </>
                  </Grid>
                  <Grid columns={[1, 2]} gap={[0, 3]}>
                    <Box sx={{ mt: 2 }}>
                      <TextInput
                        name="loanAmount"
                        label="Amount to finance"
                        autoComplete="off"
                        type="loanAmount"
                        readOnly
                      />
                     </Box>
                  </Grid>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    my: 3,
                  }}
                >
                <>
                  <Flex
                  direction="row"
                  justifyContent="start"
                  alignItems="stretch"
                  alignContent="flex-end"
                  wrap="nowrap"
                  gap="1rem"
                  >
                    <Button type="submit" sx={{ mt: 3, px: 5 }} disabled>
                      SAVE AND CONTINUE
                    </Button>
                    <Button type="button" variant="secondary" sx={{ mt: 3, px: 5 }} disabled>
                      EMAIL CUSTOMER FORM
                    </Button>
                  </Flex>
                </>
                </Box>
              </Box>
            </Card>
            </Form>
          )}
          {offers && (
          <Form
            key={SharedApp?.submittingUser?.email ?? "apply-form"}
            initialValues={{
              firstName: formData.fname || "",
              lastName: formData.lname || "",
              email: formData.email || "",
              mobile: formData.phone || "",
              state: singleState,
              offer: singleOffer || "",
              channel: formData.channel ? formData.channel : SharedApp ? SharedApp.channel : "",
              referenceId: formData.referenceNumber ? formData.referenceNumber : SharedApp ? SharedApp.referenceId : "",
              loanAmount: formData.cost ? numberToMoney(formData.cost) : SharedApp ? numberToMoney(SharedApp.loanAmount) : numberToMoney(0.00),
              autopayIntent: true,
              sendEmail: SharedApp ? SharedApp.sendEmail : false,
              salesRepFirstName: SharedApp
                ? SharedApp.submittingUser.firstName
                : "",
              salesRepLastName: SharedApp
                ? SharedApp.submittingUser.lastName
                : "",
              salesRepEmail: SharedApp ? SharedApp.submittingUser.email : "",
              salesRepPhone:
                SharedApp && SharedApp.submittingUser.phone
                  ? SharedApp.submittingUser.phone
                  : "",
            }}
            enableReinitialize={false}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={object({
              firstName: string().required(`Enter your first name`),
              lastName: string().required(`Enter your last name`),
              email: string()
                .email("Enter a valid email address, like j.doe@example.com")
                .required(`Enter the borrower's email address`),
              state: string().required(`Select state`),
              offer: string().required('Select an Offer'),
              mobile: string()
                .matches(phoneRegExp, "Enter a valid phone number")
                .required(`Enter a phone number`),
              loanAmount: string()
                        .required("Required")
                        .test("currenty", `Please enter a currency value`, val => validateMoneyInput(val))
                        .test("minAmount", `Amount must be at least ${numberToMoneyNoDecimal(minAmount)}`, val => moneyStringToNumber(val) > minAmount)
                        .test("maxAmount", `Amount must be less than ${numberToMoneyNoDecimal(maxAmount)}`, val => moneyStringToNumber(val) <= maxAmount)
            })}
            onSubmit={(values, { setFieldError }) => {
              console.log("onSubmit", values);
              const limitError = getLoanAmountLimitError(
                values.loanAmount,
                values.state,
                limitations,
                minAmount,
                maxAmount
              );
              if (limitError) {
                setFieldError("loanAmount", limitError);
                setCanApplyFromAmountCheck(false);
                return;
              }
              values.loanAmount = moneyStringToNumber(values.loanAmount);
              if (submitButtonState === 'submit') {
                values.sendEmail = false;
                handleClick(buildPaydown(values));
              } else if (submitButtonState === 'email') {
                values.sendEmail = true;
                handleEmailClick(buildPaydown(values), values.email);
              }
            }}
            showSummary={false}
          >
            <LoanAmountLimitsWatcher
              limitations={limitations}
              minAmount={minAmount}
              maxAmount={maxAmount}
              setCanApply={setCanApplyFromAmountCheck}
            />
            <LumosCard
              sx={{
                width: 960,
                margin: "0 auto",
              }}
              className="card-form"
            >
              <BackBar onClick={() => send('PREVIOUS_PAGE')}>Back</BackBar>
              <Box sx={{ pl: 2, pr: 2, pb: 2, pt: 3 }}>
                <Text>
                  <span style={styles.bold}>Welcome!</span> Complete this form to see an ESTIMATED payment scenario. Use the $ amount suggested by our company representative.
                  If you have questions, reach out to <span style={styles.bold}>{SharedApp.submittingUser.firstName}</span> at <a href={`tel:${SharedApp.submittingUser.phone}`}>{phone(SharedApp.submittingUser.phone)}</a> or <a href={`mailto:${SharedApp.submittingUser.email}`}>{SharedApp.submittingUser.email}</a>.
                </Text>
                <Box as="p" sx={{ mb: 2 }}>
                  &nbsp;
                </Box>
                <Box>
                  <Grid columns={[1, 2]} gap={[0, 3]}>
                    <TextInput
                      name="firstName"
                      label="First name"
                      autoComplete="off"
                      readOnly={formData.fname !== "" && formData.locked ? true : false}
                    />
                    <TextInput
                      name="lastName"
                      label="Last name"
                      autoComplete="off"
                      readOnly={formData.lname !== "" && formData.locked ? true : false}
                    />
                  </Grid>
                  <Grid columns={[1, 2]} gap={[0, 3]}>
                    <TextInput
                      name="email"
                      label="Email address"
                      autoComplete="off"
                      type="email"
                      readOnly={formData.email !== "" && formData.locked ? true : false}
                    />
                    <TextInput
                      name="mobile"
                      label="Mobile number"
                      autoComplete="off"
                      type="phone"
                      description="Please enter 10 digit mobile number"
                      readOnly={formData.phone !== "" && formData.locked ? true : false}
                    />
                  </Grid>
                  {!offers && (
                  <Box sx={{ width: "100%", mb: 2, mt: 2  }}>
                  <Loader
                      variation="linear"
                      emptyColor="#ffffff"
                      filledColor="#F58320"
                      className="loader"
                      />
                   </Box>
                   )}
                  <Grid columns={[1, 2]} gap={[0, 3]}>
                    <Box sx={{ width: "100%", mr: 5, mt: 2 }}>
                      <SingleSelect
                        dangerouslyOnChange={(e) => {
                          setSingleOffer(e);
                          const offer = offers.find(({id}) => id === e )
                          if (offer) {
                            setOfferDesc(offer.productDescription);
                            setOfferName(offer.name);
                            getPayment(e, paymentAmount.amount);
                            const resolvedStates = resolveApplyStateEntries(
                              SharedApp.states,
                              offer.states
                            );
                            setStates(JSON.stringify(resolvedStates));
                            setStatesItems(toStateSelectItems(resolvedStates));
                            if (state.context.selectedState) {
                              setSingleState(state.context.selectedState);
                            } else if (resolvedStates.length === 1) {
                              setSingleState(resolvedStates[0]);
                            }

                          }
                        }}
                        name="offer"
                        label={`Offer`}
                        items={offerItems}
                        readOnly={offerItems.find(offer => offer.value === formData.offerId) !== undefined && formData.locked ? true : false}
                      />
                      {/* <Text sx={{position: "relative", top: "-15px"}} variant="small">{offerDesc}</Text> */}
                    </Box>
                    {!statesItems.length && (
                      <Box sx={{ width: "30%", mr: 5, mt: 2 }}>
                       <SingleSelect
                        name="state"
                        label={"State"}
                        readOnly
                        description="Select an offer first"
                        size={20}
                        items={[]}
                      />
                      </Box>
                    )}
                    {statesItems.length > 0 && (
                    <Box sx={{ width: "30%", mr: 5, mt: 2 }}>
                      <ApplyStatesInput
                        statesItems={statesItems}
                        limitations={limitations}
                        minAmount={minAmount}
                        maxAmount={maxAmount}
                        setLoadingPayment={setLoadingPayment}
                        setCanApply={setCanApplyFromAmountCheck}
                        readOnly={
                          statesItems.find(st => st.value === formData.state) !== undefined &&
                          formData.locked
                        }
                      />
                    </Box>
                  )}
                  </Grid>
                  <Grid columns={[1, 2]} gap={[0, 3]}>
                    <Box sx={{ mt: 2 }}>
                      <LoanAmountInput
                        isEmbedded={isEmbedded}
                        readOnly={formData.cost !== "" && formData.locked}
                        singleOffer={singleOffer}
                        limitations={limitations}
                        minAmount={minAmount}
                        maxAmount={maxAmount}
                        setPaymentAmount={setPaymentAmount}
                        setCanApply={setCanApplyFromAmountCheck}
                      />
                     </Box>
                  </Grid>
                </Box>
                {payment && version === "2.0" &&
                <LumosCard
                    header={{
                      title: (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <img src={getCategory(SharedApp.category)} alt={getCategoryName(SharedApp.category)} style={styles.catLogo} />
                          {getCategoryName(SharedApp.category)} estimated loan details
                        </Box>
                      ),
                    }}
                  >
                <Box
                sx={{
                    pt: 3,
                    mt: 3,
                    borderTop: "1px solid",
                    borderTopColor: "neutral.l3",
                  }}>
                  <Grid columns={[1, 1, '1fr 2fr 2fr']}>
                    <Box
                      sx={{
                        borderRight: '1px solid',
                        borderColor: ['transparent', 'transparent', 'neutral.l3'],
                        mb: 3,
                      }}
                    >
                      <div>Loan amount</div>
                      <FormLoanAmountText />
                    </Box>
                    <Box
                      sx={{
                        borderRight: '1px solid',
                        borderColor: ['transparent', 'transparent', 'neutral.l3'],
                        mb: 3,
                        pr: 2,
                      }}
                    >
                      <DataList columns={1} items={productItems} />
                    </Box>
                    <Box sx={{ mb: 3 }}>
                      <DataList columns={1} items={estimatedPayment} />
                    </Box>
                  </Grid>
                </Box>
                </LumosCard>}
                <ApplyCaptchaAndSubmit
                  canApply={canApply}
                  setCanApply={setCanApply}
                  setCaptchaResponse={setCaptchaResponse}
                  captchaRef={captchaRef}
                  limitations={limitations}
                  minAmount={minAmount}
                  maxAmount={maxAmount}
                  loanAmountBlockedRef={loanAmountBlockedRef}
                  onCaptchaExpired={handleCaptchaExpired}
                  renderActions={({ enabled }) => (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-start",
                        my: 3,
                      }}
                    >
                      <Flex
                        direction={{ base: "column", large: "row" }}
                        justifyContent="start"
                        alignItems="stretch"
                        alignContent="flex-end"
                        wrap="nowrap"
                        gap="1rem"
                      >
                        <Button
                          type="submit"
                          onClick={() => handleSubmitButtonState("submit")}
                          disabled={!enabled || isLoading}
                          sx={{ mt: 3, px: 5 }}
                        >
                          {isLoading ? (
                            <div styles={styles.isLoading}>
                              <Spinner size={20} sx={{ mr: 2, mb: -1 }} />
                              SAVING...
                            </div>
                          ) : (
                            "SAVE AND CONTINUE"
                          )}
                        </Button>
                        <Button
                          type="submit"
                          onClick={() => handleSubmitButtonState("email")}
                          disabled={!enabled || isSending}
                          variant="secondary"
                          sx={{ mt: 3, px: 5 }}
                        >
                          {isSending ? (
                            <div styles={styles.isSending}>
                              <Spinner size={20} sx={{ mr: 2, mb: -1 }} />
                              SENDING...
                            </div>
                          ) : (
                            "EMAIL CUSTOMER FORM"
                          )}
                        </Button>
                      </Flex>
                    </Box>
                  )}
                />
              </Box>
            </LumosCard>
          </Form>
          )}
        </Box>
      )}
    </>
  );
};

const styles = {
  logo: {
    width: 150,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: 4,
  },
  heading: {
    backgroundColor: "#003439",
  },
  loader: {
    height: "5rem"
  },
  period: {
     display: 'inline', fontSize: '70%', fontWeight: 'normal'
  },
  catLogo: {
    width: 24,
    position: "relative",
    top: 0,
    margin: "0 10px",
  },
  bold: {
    fontWeight: 600
  }
};

export default Main;
